module.exports = __webpack_public_path__ + "static/media/audio_loading.045e9d98.gif";